import {
    drawLine,
    drawDot
} from "./helpers.js";

let dots = [
    { x: 182, y: 182 },
    { x: 413, y: 182 },
    { x: 413, y: 92 },
    { x: 182, y: 92 },
];

let lastX, lastY;
export function mouseMovePenTool(e, canvas, originalCanvas, ratio, image, scale) {

    e.preventDefault();


    let mouseX = Number;
    let mouseY = Number;
    const color = '#12F';
    let size = 20;

    const ctx = canvas.getContext('2d');
    const originalCtx = originalCanvas.getContext('2d');

    if (window.TouchEvent && (e instanceof TouchEvent)) {
        const rect = e.target.getBoundingClientRect();
        mouseX = e.touches[0].clientX - rect.x;
        mouseY = e.touches[0].clientY - rect.y;
    } else {
        mouseX = e.offsetX;
        mouseY = e.offsetY;
    }

    let item = {
        isDummy: false,
        x: mouseX,
        y: mouseY,
        c: color,
        r: size
    }
    const imageScaledWidth = image.width * ratio;
    const imageScaledHeight = image.height * ratio;
    const canvasW = canvas.width;
    const offsetX = (canvas.width - imageScaledWidth) / 2;
    const offsetY = (canvas.height - imageScaledHeight) / 2;
    let x = mouseX;
    let y = mouseY;
    console.log("mouseX", mouseX - offsetX, "mouseY", mouseY - offsetY, offsetX, offsetY)

    // dots=[{x:mouseX-offsetX,y:mouseY-off}]
    // drawImageBoundary(dots,canvas,ratio,image)
    // drawImageBoundaryScaled(dots, originalCanvas,ratio,image)
    // if (prevPoints == null) {
    //     return drawDot({ x: mouseX, y: mouseY }, canvas, '#12F');
    // }else{

    //     drawLine({ x: mouseX, y: mouseY }, prevPoints, canvas, '#12F');
    // }
    // prevPoints = { x: mouseX, y: mouseY };
    // console.log('HEREEEE')

    // function Draw(x, y) {
    // console.log("image",canvas)
    // // const centerShiftX = (canvas.width - img.width * ratio) / 2;
    // // const centerShiftY = (canvas.height - img.height * ratio) / 2;
    // // const csX = centerShiftX;
    // // const csY = centerShiftY;
    // const ohRatio = originalCanvas.width / image.width;
    // const ovRatio = originalCanvas.height / image.height;
    // const ratio = Math.min(ohRatio, ovRatio);
    // const ocenterShiftX = (originalCanvas.width - image.width * ratio) / 2;
    // const ocenterShiftY = (originalCanvas.height - image.height * ratio) / 2;
    // // console.log("ratio",ratio,"chentershit",csX,csY)
    // // console.log("ratio",ratio,"chentershit",csX,csY)
    // console.log("mouse Position", x, y, "scaled",(x * ratio),'ratio',ratio )
    originalCtx.beginPath();
    originalCtx.strokeStyle = '#fff';
    originalCtx.lineWidth = 16;
    originalCtx.lineJoin = "round";
    originalCtx.moveTo(((lastX * scale - offsetX)) / ratio, ((lastY * scale - offsetY)) / ratio);
    originalCtx.lineTo(((x * scale - offsetX + 0.1)) / ratio, ((y * scale - offsetY + 0.1)) / ratio);
    originalCtx.closePath();
    originalCtx.stroke();
    // console.log(x, y, lastX, lastY)
    ctx.beginPath();
    ctx.strokeStyle = '#fff';
    ctx.lineWidth = 9;
    ctx.lineJoin = "round";
    ctx.moveTo(lastX, lastY);
    ctx.lineTo(x, y);
    ctx.closePath();
    ctx.stroke();
    lastX = x; lastY = y;
    lastX = x; lastY = y;
    // }
    // function mapDrawOnOriginal(x, y, ratio) {
    // }
    // Draw(mouseX, mouseY);
    // mapDrawOnOriginal(mouseX, mouseY, ratio);

    // history.push(item)
    // draw(item, history.length)
    // drawToLayer(item, history.length)


    // function draw(item, i) {
    //     const ctx = canvas.getContext('2d');
    //     ctx.lineCap = 'round'
    //     ctx.lineJoin = 'round'

    //     let prevItem = history[i - 2]
    //     if (i < 2) {
    //         return false
    //     }

    //     if (!item.isDummy && !history[i - 1].isDummy && !prevItem.isDummy) {
    //         ctx.strokeStyle = item.c
    //         ctx.lineWidth = item.r

    //         ctx.beginPath()
    //         ctx.moveTo(prevItem.x, prevItem.y)
    //         ctx.lineTo(item.x, item.y)
    //         ctx.stroke()
    //         ctx.closePath()
    //     } else if (!item.isDummy) {
    //         ctx.strokeStyle = item.c
    //         ctx.lineWidth = item.r

    //         ctx.beginPath()
    //         ctx.moveTo(item.x, item.y)
    //         ctx.lineTo(item.x, item.y)
    //         ctx.stroke()
    //         ctx.closePath()
    //     }
    // }

    // function drawToLayer(item, i) {
    //     let ctx = originalCanvas.getContext('2d');
    //     // let ratio = ratio
    //     ctx.lineCap = 'round'
    //     ctx.lineJoin = 'round'

    //     let prevItem = history[i - 2]
    //     console.log(prevItem)

    //     if (i < 2) {
    //         return false
    //     }

    //     if (!item.isDummy && !history[i - 1].isDummy && !prevItem.isDummy) {
    //         ctx.strokeStyle = item.c
    //         ctx.lineWidth = item.r * ratio

    //         ctx.beginPath()
    //         ctx.moveTo(prevItem.x * ratio, prevItem.y * ratio)
    //         ctx.lineTo(item.x * ratio, item.y * ratio)
    //         console.log(ratio)
    //         ctx.stroke()
    //         ctx.closePath()
    //     } else if (!item.isDummy) {
    //         ctx.strokeStyle = item.c
    //         ctx.lineWidth = item.r * ratio

    //         ctx.beginPath()
    //         ctx.moveTo(item.x * ratio, item.y * ratio)
    //         ctx.lineTo(item.x * ratio, item.y * ratio)
    //         ctx.stroke()
    //         ctx.closePath()
    //     }
    // }


}

export function resetLastCoordinates() {
    lastX = Number;
    lastY = Number;
}